import Dropdown from "../../commons/components/dropdown/Dropdown";
import * as React from "react";
import { FLOWS_DROPDOWN_OPTIONS, getDropdownValue } from "../model/FlowsDropdownOptions";
import "./FlowEdition.scss";
import { Flow } from "../model/Flow";
import { createRoot } from "react-dom/client";
import FlowType from "../../commons/model/FlowType";

interface FlowEditionProps {
  isError?: boolean;
  initialFlow: Flow;
  onFlowChange: (flowToUpdate: Flow) => any;
}

export default function FlowEdition({ isError, initialFlow, onFlowChange }: FlowEditionProps) {
  const onFlowTypeChange = (newFlowType: FlowType) => {
    onFlowChange({ ...initialFlow, type: newFlowType });
  };

  const onFlowNameChange = (newFlowName: string) => {
    onFlowChange({ ...initialFlow, name: newFlowName });
  };

  return (
    <>
      <div className="flex-center flow-name">
        <i className="ic_edit"></i>
        <input
          className="flow-name-input"
          type="text"
          defaultValue={initialFlow.name}
          placeholder={
            i18n["Page.Settings.Customisation.Flow.Integration.Modal.FlowName.Placeholder"]
          }
          onChange={(event) => onFlowNameChange(event.target.value)}
        />
      </div>
      <Dropdown
        options={FLOWS_DROPDOWN_OPTIONS}
        onChange={(newFlowType) => onFlowTypeChange(newFlowType)}
        additionalClass={`flow-type-list ${isError ? "dropdown-error" : ""}`}
        defaultValue={getDropdownValue(initialFlow.type)}
      ></Dropdown>
    </>
  );
}

FlowEdition.loadComponent = (elementId: string, props: FlowEditionProps) => {
  const container = document.getElementById(elementId);
  const root = createRoot(container!);
  root.render(<FlowEdition {...props} />);
};
